// Logger utility for debugging and monitoring
const Logger = {
    logs: [],
    maxLogs: 500,
    enabled: true,
    listeners: [],

    LEVELS: {
        DEBUG: { name: 'DEBUG', color: '#888', priority: 0 },
        INFO: { name: 'INFO', color: '#4CAF50', priority: 1 },
        WARN: { name: 'WARN', color: '#FF9800', priority: 2 },
        ERROR: { name: 'ERROR', color: '#F44336', priority: 3 },
        API: { name: 'API', color: '#2196F3', priority: 1 },
    },

    log(level, category, message, data = null) {
        if (!this.enabled) return;

        const entry = {
            id: Date.now() + Math.random(),
            timestamp: new Date().toISOString(),
            time: new Date().toLocaleTimeString('vi-VN'),
            level: level.name,
            levelColor: level.color,
            category,
            message,
            data: data ? JSON.stringify(data, null, 2) : null,
        };

        this.logs.unshift(entry);
        if (this.logs.length > this.maxLogs) {
            this.logs = this.logs.slice(0, this.maxLogs);
        }

        // Console output
        const consoleStyle = `color: ${level.color}; font-weight: bold;`;
        console.log(`%c[${level.name}][${category}]`, consoleStyle, message, data || '');

        // Notify listeners
        this.listeners.forEach(fn => fn(entry));
    },

    debug(category, message, data) { this.log(this.LEVELS.DEBUG, category, message, data); },
    info(category, message, data) { this.log(this.LEVELS.INFO, category, message, data); },
    warn(category, message, data) { this.log(this.LEVELS.WARN, category, message, data); },
    error(category, message, data) { this.log(this.LEVELS.ERROR, category, message, data); },
    api(category, message, data) { this.log(this.LEVELS.API, category, message, data); },

    subscribe(fn) {
        this.listeners.push(fn);
        return () => { this.listeners = this.listeners.filter(f => f !== fn); };
    },

    getLogs(filter = {}) {
        let result = [...this.logs];
        if (filter.level) {
            result = result.filter(l => l.level === filter.level);
        }
        if (filter.category) {
            result = result.filter(l => l.category.toLowerCase().includes(filter.category.toLowerCase()));
        }
        if (filter.search) {
            const search = filter.search.toLowerCase();
            result = result.filter(l =>
                l.message.toLowerCase().includes(search) ||
                (l.data && l.data.toLowerCase().includes(search))
            );
        }
        return result;
    },

    clear() {
        this.logs = [];
        this.listeners.forEach(fn => fn(null));
    },

    exportLogs() {
        const data = JSON.stringify(this.logs, null, 2);
        const blob = new Blob([data], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `thiet-chuan-logs-${new Date().toISOString().slice(0, 10)}.json`;
        a.click();
        URL.revokeObjectURL(url);
    }
};

// Initialize logger
Logger.info('APP', 'Thiệt Chuẩn AI initialized', { version: '2.0', timestamp: new Date().toISOString() });

export default Logger;
